<script lang="ts" setup>
import type { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";
import { useBaseView } from "@/composables";
import { computed } from "vue";
import OmniTooltip from "@/components/OmniTooltip.vue";

const { hasAccess } = useBaseView();

const props = withDefaults(
  defineProps<{
    permission: DispatcherPermissionValue;
    fullWidth?: boolean;
  }>(),
  {
    fullWidth: false,
  },
);

const hasAccessTo = computed(() => {
  return hasAccess(props.permission);
});
</script>

<template>
  <omni-tooltip :disabled="hasAccessTo" :full-width="fullWidth">
    <template #activator>
      <slot name="activator" v-bind="{ disabled: !hasAccessTo }"></slot>
    </template>

    <slot></slot>
  </omni-tooltip>
</template>
